let headerFlag        = false;
let stHeader  = document.getElementById('st-Header');
let stHeaderNav  = document.getElementById('st-Header_Nav');
let stHeaderBg  = document.getElementById('st-Header_Bg');
let headerButton  = document.getElementById('st-Menu');


// ------------------------------------------------------------------------
// preload
// ----- BOTH
// ------------------------------------------------------------------------
const preload = () =>{

  history.replaceState(null, null, null);
  window.addEventListener('popstate', function() {

    $('body').addClass('preload');

    headerFlag        = false;
    stHeaderNav.classList.remove('opened');
    headerButton.classList.remove('opened');
    stHeaderBg.classList.remove('opened');
    stHeaderNav.classList.add('closed');
    headerButton.classList.add('closed');
    stHeaderBg.classList.add('closed');

    setTimeout(function(){
      $('body').removeClass('preload');
    },100);

  }, false);

  $(window).on('load' , function() {
    $("body").removeClass("preload");
  });

};

// ------------------------------------------------------------------------
// toggleHeader
// ----- BOTH
// ------------------------------------------------------------------------
const toggleHeader = () => {


  headerButton.addEventListener('click', () => {

    if(!headerFlag){
      // $('#st-Header_Navi').css({'display':'block'});
      setTimeout(function(){
        stHeaderNav.classList.remove('closed');
        headerButton.classList.remove('closed');
        stHeaderBg.classList.remove('closed');
        stHeaderNav.classList.add('opened');
        headerButton.classList.add('opened');
        stHeaderBg.classList.add('opened');
        headerFlag = true;
  		},0);
    }else{
      stHeaderNav.classList.remove('opened');
      headerButton.classList.remove('opened');
      stHeaderBg.classList.remove('opened');
      stHeaderNav.classList.add('closed');
      headerButton.classList.add('closed');
      stHeaderBg.classList.add('closed');
      headerFlag = false;
      // setTimeout(function(){
      //   // $('#st-Header_Navi').css({'display':'none'});
  		// },0);
    }
  }, false);


};



// ------------------------------------------------------------------------
// showMovie
// ----- BOTH
// ------------------------------------------------------------------------
const showMovie = () => {
  const $modal = $('#sw-Youtube');
  const $content = $('#sw-Youtube_Content');

  // open
  $('.js-Youtube').on('click', function(){

    const dataID = $(this).attr('data-youtube');

    $('#sw-Youtube').css({'opacity':'0','display':'block'}).stop().animate({'opacity':'1','width':100+'%','height':100+'vh','top':0,'left':0},500,'easeOutQuart',function(){
      //iframe append
      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/'+dataID+'?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
      // fadeIn
      $modal.stop().fadeIn(400);
      return false;
    });
  });


  //close
  $('#sw-Youtube_Close,#sw-Youtube_Overlay').on('click', function(){

    $('#sw-Youtube').css({'opacity':'1'}).stop().animate({'opacity':'0'},500,'easeOutQuart',function(){
      $('#sw-Youtube').css({'display':'none'});
      $content.children('iframe').remove();
		});
  });

};


// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {

  //ページ外からのページ内リンク
  var urlHash = location.hash;
  if(urlHash) {
      $('body,html').stop().scrollTop(0);
      setTimeout(function(){
          var target = $(urlHash);
          var position = target.offset().top - 80;
          $('body,html').stop().animate({scrollTop:position}, 500);
      }, 200);
  }

  var linkSpeed    = 1000;
  var linkAdjust   = 50;

  //ページ内リンク
  $("a[href^='#']").on("click", function(){

    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkPosition = linkTarget.offset().top;

    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "easeInOutQuint");
    return false;
  });

};


// ------------------------------------------------------------------------
// parallaxHennnyano
// ----- BOTH
// ------------------------------------------------------------------------
const parallaxHennnyano = () => {
  var layer = document.getElementById('sw-Hennnyano');
  var parallax = new Parallax(layer, {
    clipRelativeInput: true, //要素の端にカーソルが達したら動きを止める
    hoverOnly: false, //カーソルが要素の上にある場合のみ有効
    invertX: false, //X軸の動きを反転。falseにするとマウスと同じ方向に動く
    invertY: false, //Y軸の動きを反転。falseにするとマウスと同じ方向に動く
    limitX: true, //X軸の動きを制限する
    limitY: true, //Y軸の動きを制限する
    scalarX: 30.0, //X軸の移動速度と範囲を増減
    scalarY: 30.0, //Y軸の移動速度と範囲を増減
    frictionX: .1, //X軸のレイヤーの速度。0.00〜1.00の範囲内で指定可能
    frictionY: .1, //Y軸のレイヤーの速度。0.00〜1.00の範囲内で指定可能
    originX: .2, //X軸のマウスの初期位置。デフォルトの0.5は画面または要素の中心
    originY: 1, //Y軸マウスの初期位置。デフォルトの0.5は画面または要素の中心
  });
};

// ------------------------------------------------------------------------
// pageTop
// ----- BOTH
// ------------------------------------------------------------------------
const pageTop = () => {

  $("#sw-Hennnyano").on("click", function(){
    const linkSpeed    = 1200;
    // $("html, body").animate({scrollTop: 0}, linkSpeed, "easeOutExpo");
    // return false;

    setTimeout(function(){
      $("html, body").animate({scrollTop: 0}, linkSpeed, "easeOutExpo");
    },1000);

    const windowH = $(window).innerHeight();
    const hennnyanoH = $("#sw-Hennnyano").innerHeight();
    const visibleHeight = hennnyanoH * .7;
    const moveHeight = windowH + visibleHeight * 1.5;
    const sinkHeight = hennnyanoH * .44;

    anime({
      targets: '#sw-Hennnyano',
      translateY: [
        { value: sinkHeight, duration: 700, delay: 0, easing: 'easeInOutCubic'},
        // { value: 40, duration: 500, delay: 1000 },
        { value: -moveHeight, duration: 1200, delay: 200, easing: 'easeOutCubic'},
        { value: visibleHeight, duration: 0, delay: 0 },
        { value: 0, duration: 1300, delay: 0 },
      ],
      easing: 'easeOutElastic(1, .8)',
      loop: false
    });
  });
};


export {
  preload,
  toggleHeader,
  showMovie,
  anchorLink,
  parallaxHennnyano,
  pageTop,
}



// WEBPACK FOOTER //
// ./src/amashiro_v0/assets/js/include/module.js